import { v2SaleContract } from "config";
import { useContractRead } from "wagmi";

const useSaleState = (): [
  isActive: boolean | undefined,
  readSaleState: () => void
] => {
  const [{ data: saleStateData }, readSaleState] = useContractRead(
    {
      addressOrName: v2SaleContract.address,
      contractInterface: v2SaleContract.interface,
    },
    "saleState"
  );

  if (saleStateData === undefined) {
    return [undefined, readSaleState];
  }

  return [(saleStateData as any as number) === 1 ? true : false, readSaleState];
};

export default useSaleState;
